import React from 'react';
import { useNavigate } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment';

const isLate = (complaint) => {
  const isBefore = moment(complaint.datePrevision).isBefore(moment(), 'days');
  const isNewOrAnalisys = complaint.status === "Novo" || complaint.status === "Em análise";
  return isBefore && isNewOrAnalisys;
}

export default function InfoComplaint({ complaints, typeComplaint }) {

  const navigate = useNavigate();

  return (
    <div>
      {/* voltar id para essa div v */}
      <div id='allcomplaints' className="list-ocorrencias">
        <ul>
          {complaints.map(complaint => (
            <li key={complaint.id} className={isLate(complaint) ? "container-red" : "container-blue"}>
              <strong>CÓDIGO:
                <span>{complaint.reference}</span>
              </strong>

              <strong>TIPO:
                <span>{complaint.area}</span>
              </strong>

              <strong>BAIRRO:
                <span>{complaint.neighborhood}</span>
              </strong>

              <strong>stepStatus:
                <span>{complaint.validationControl}</span>
              </strong>

              <strong>CRIAÇÃO:
                <span>
                  <Moment locale format={'DD/MM/YYYY HH:mm'}>
                    {complaint.createdAt}
                  </Moment>
                </span>
              </strong>

              <strong>STATUS:
                <span className={complaint.status === 'Em análise' ? 'analise' :
                  complaint.status === 'Resolvido' ? 'resolvido' :
                    complaint.status === 'Indeferido' ? 'indeferido' :
                      //  complaint.status==='Homologado' ? 'homologado' :
                      complaint.status === 'Novo' ? 'novo' : 'novo'}>{complaint.status}
                </span>
              </strong>

              <strong>RESPONSÁVEL:
                <span>{complaint.executorName === undefined ? 'Sem executor' : complaint.executorName}</span>
              </strong>

              <div className="button-info-complaint" onClick={() => navigate(`/details/${complaint.id}`, { state: { from: [{ name: 'Ocorrências', href: '/search' }] } })}>
                Ver Detalhes
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div >
  )
}